import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_DISTRICTS_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_DISTRICTS_DETAIL_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_DISTRICTS_DETAIL_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/districts/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
